import SentryService from '/@/integrations/sentry/SentryService';
import { user, echo } from '@/modules/auth/store/auth.state';
import { AuthUser } from '@/modules/auth/models/AuthUser';
import { CurrentEstate } from '@/modules/estate/models/CurrentEstate';
import { EstateAccount } from '@/modules/estateaccount/models/EstateAccount';
import Echo from 'laravel-echo';
import { StripeCoupon } from '@/modules/billing/models/stripe/StripeCoupon';
import EventBus from '@/modules/core/app/helpers/EventBus';
import { AuthUserEvent } from '@/modules/auth/events/AuthUserEvent';
import { Team } from '@/modules/team/models/Team';

export function setUser(value: AuthUser): void {
  user.value = value?.id ? value : null;
  SentryService.setContext(user.value);

  EventBus.signal(AuthUserEvent.USER_CHANGED, user.value);
}

export function setCurrentTeam(team?: Team): void {
  if (!user.value) {
    return;
  }

  user.value.currentTeam = team;
}

export function setIsViewingEstateDetails(estate?: CurrentEstate | null): void {
  if (!user.value) {
    return;
  }

  user.value.isViewingEstateDetails = true;
  if (!estate) {
    return;
  }

  user.value.currentEstate = estate;
  user.value.estateAccount = estate.estateAccounts?.find(
    (estateAccount: EstateAccount) => estateAccount.userId === user.value?.id
  );

  EventBus.signal(AuthUserEvent.USER_CHANGED, user.value);
}

export function unsetIsViewingEstateDetails(): void {
  if (!user.value || !user.value.isViewingEstateDetails) {
    return;
  }

  user.value.isViewingEstateDetails = false;
  user.value.currentEstate = null;
  user.value.estateAccount = null;

  EventBus.signal(AuthUserEvent.USER_CHANGED, user.value);
}

export function setPermissionKeys(permissionKeys: string[]): void {
  if (!user.value) {
    return;
  }

  user.value.permission!.keys = permissionKeys;
}

export function setEchoInstance(echoInstance: Echo | undefined): void {
  echo.value = echoInstance;
}

export function setHasViewedClaraForPlannersLauncher(): void {
  if (!user.value) {
    return;
  }

  user.value.hasViewedClaraForPlannersLauncher = true;
}

export function setInvitationStripeCoupon(coupon: StripeCoupon): void {
  if (user.value?.partnershipInvitation) {
    user.value.partnershipInvitation.coupon = coupon;
  }
}
